export default __webpack_public_path__ + "static/media/440.b77ceb0f.jpg";